// fruits
export const GET_FRUITS = "GET_FRUITS";

// signup types
export const SIGNUP = "SIGNUP";

// login types
export const LOGIN = "LOGIN";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";
export const LOGOUT_ERROR = "LOGOUT_ERROR";
export const RESET_STORE = "RESET_STORE";
export const CHANGE_LOGIN_STATUS = "CHANGE_LOGIN_STATUS";
export const CLEAN_STORE = "CLEAN_STORE";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const MANUALLY_TRIGGER_AUTENTICATION = "MANUALLY_TRIGGER_AUTENTICATION";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";

// basic account types
export const UPDATE_ME = "UPDATE_ME";
export const UPDATE_ME_ERROR = "UPDATE_ME_ERROR";

// processors
export const GET_PROCESSORS = "GET_PROCESSORS";
export const ADD_PROCESSOR = "ADD_PROCESSOR";
export const UPDATE_PROCESSOR = "UPDATE_PROCESSOR";
export const DELETE_PROCESSOR = "DELETE_PROCESSOR";
export const GET_PROCESSORS_ERROR = "GET_PROCESSORS_ERROR";
export const ADD_PROCESSOR_ERROR = "ADD_PROCESSOR_ERROR";
export const UPDATE_PROCESSOR_ERROR = "UPDATE_PROCESSOR_ERROR";
export const DELETE_PROCESSOR_ERROR = "DELETE_PROCESSOR_ERROR";
export const GET_ACTIVE_PROCESSORS = "GET_ACTIVE_PROCESSORS";
export const GET_ACTIVE_PROCESSORS_ERROR = "GET_ACTIVE_PROCESSORS_ERROR";

// categories
export const GET_CATEGORIES = "GET_CATEGORIES";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const UPDATE_CATEGORY = "UPDATE_CATEGORY";
export const DELETE_CATEGORY = "DELETE_CATEGORY";
export const GET_CATEGORIES_ERROR = "GET_CATEGORIES_ERROR";
export const ADD_CATEGORY_ERROR = "ADD_CATEGORY_ERROR";
export const UPDATE_CATEGORY_ERROR = "UPDATE_CATEGORY_ERROR";
export const DELETE_CATEGORY_ERROR = "DELETE_CATEGORY_ERROR";
export const GET_ACTIVE_CATEGORIES = "GET_ACTIVE_CATEGORIES";
export const GET_ACTIVE_CATEGORIES_ERROR = "GET_ACTIVE_CATEGORIES_ERROR";

// papers
export const GET_CERTAIN_CATEGORY_PAPER_NUMBER =
  "GET_CERTAIN_CATEGORY_PAPER_NUMBER";
export const GET_RECIPIENT_AND_SENDERS = "GET_RECIPIENT_AND_SENDERS";
export const ADD_PAPER = "ADD_PAPER";
export const ADD_PAPER_ERROR = "ADD_PAPER_ERROR";
export const RESET_PAPER_STORE = "RESET_PAPER_STORE";
export const CATEGORY_VALUE_0 = "CATEGORY_VALUE_0";
export const GET_ALL_PAGE_PAPERS = "GET_ALL_PAGE_PAPERS";
export const GET_CERTAIN_PAGE_PAPERS = "GET_CERTAIN_PAGE_PAPERS";
export const ALL_PAPERS_NUMBER = "ALL_PAPERS_NUMBER";
export const CURRENT_YEAR_PAPERS_NUMBER = "CURRENT_YEAR_PAPERS_NUMBER";
export const GET_NOT_ARCHIVED_PAGE_PAPERS = "GET_NOT_ARCHIVED_PAGE_PAPERS";
export const NOT_ARCHIVED_PAPERS_NUMBER = "NOT_ARCHIVED_PAPERS_NUMBER";
export const GET_CERTAIN_PAPER = "GET_CERTAIN_PAPER";
export const GET_CERTAIN_PAPER_ERROR = "GET_CERTAIN_PAPER_ERROR";
export const UPDATE_CERTAIN_PAPER = "UPDATE_CERTAIN_PAPER";
export const UPDATE_CERTAIN_PAPER_ERROR = "UPDATE_CERTAIN_PAPER_ERROR";

// current user
export const GET_CURRENT_USER_DATA = "GET_CURRENT_USER_DATA";
export const GET_CURRENT_USER_DATA_ERROR = "GET_CURRENT_USER_DATA_ERROR";
export const UPDATE_CURRENT_USER_DATA = "UPDATE_CURRENT_USER_DATA";
export const UPDATE_CURRENT_USER_DATA_ERROR = "UPDATE_CURRENT_USER_DATA_ERROR";
export const MANUALLY_TRIGGER_STATUS = "MANUALLY_TRIGGER_STATUS";
export const UPDATE_CURRENT_DATA_PASSWORD = "UPDATE_CURRENT_DATA_PASSWORD";
export const UPDATE_CURRENT_DATA_PASSWORD_ERROR =
  "UPDATE_CURRENT_DATA_PASSWORD_ERROR";

// archive
export const POST_PREPARING_FOR_ARCHIVE = "POST_PREPARING_FOR_ARCHIVE ";
export const POST_PREPARING_FOR_ARCHIVE_ERROR =
  "POST_PREPARING_FOR_ARCHIVE_ERROR";
export const POST_CREATE_ARCHIVE = "POST_CREATE_ARCHIVE ";
export const POST_CREATE_ARCHIVE_ERROR = "POST_CREATE_ARCHIVE_ERROR";
export const MANUALLY_TRIGGER_MESSAGE = "MANUALLY_TRIGGER_MESSAGE";
export const DELETE_ARCHIVED_ITEM = "DELETE_ARCHIVED_ITEM";
export const GET_ARCHIVE = "GET_ARCHIVE";
export const GET_CURRENT_YEAR_ARCHIVE = "GET_CURRENT_YEAR_ARCHIVE";
export const GET_ARCHIVE_NUMBER = "GET_ARCHIVE_NUMBER";
export const GET_CURRENT_YEAR_ARCHIVE_NUMBER =
  "GET_CURRENT_YEAR_ARCHIVE_NUMBER";
export const GET_ARCHIVES_FOR_DESTROYING = "GET_ARCHIVES_FOR_DESTROYING";
export const UPDATE_ARCHIVE = "UPDATE_ARCHIVE";
export const UPDATE_ARCHIVE_ERROR = "UPDATE_ARCHIVE_ERROR";
export const GET_ARHIVE_FOR_WORD = "GET_ARHIVE_FOR_WORD";
export const GET_ARHIVE_FOR_WORD_ERROR = "GET_ARHIVE_FOR_WORD_ERROR";
export const GET_CERTAIN_ARCHIVE = "GET_CERTAIN_ARCHIVE";
export const GET_CERTAIN_ARCHIVE_ERROR = "GET_CERTAIN_ARCHIVE_ERROR";
export const UPDATE_CERTAIN_ARCHIVE = "UPDATE_CERTAIN_ARCHIVE";
export const UPDATE_CERTAIN_ARCHIVE_ERROR = "UPDATE_CERTAIN_ARCHIVE_ERROR";

// all users
export const GET_ALL_USERS = "ALL_USERS";
export const GET_ALL_USERS_ERROR = "ALL_USERS_ERROR";
export const GET_CERTAIN_USER = "GET_CERTAIN_USER";
export const GET_CERTAIN_USER_ERROR = "GET_CERTAIN_USER_ERROR";
export const GET_COUNT_ALL_USERS = "GET_COUNT_ALL_USERS";
export const GET_COUNT_ALL_USERS_ERROR = "GET_COUNT_ALL_USERS_ERROR";
export const MANUALLY_TRIGGER_ROLE = "MANUALLY_TRIGGER_ROLE";
export const UPDATE_CERTAIN_USER = "UPDATE_CERTAIN_USER";
export const UPDATE_CERTAIN_USER_ERROR = "UPDATE_CERTAIN_USER_ERROR";
export const DELETE_CERTAIN_USER = "DELETE_CERTAIN_USER";
export const DELETE_CERTAIN_USER_ERROR = "DELETE_CERTAIN_USER_ERROR";
